import React, { useState } from 'react';
import NoImageIcon from 'assets/svg/no-ava-ic.svg';
import * as Styled from './styled';
import { Button } from 'ds/components/button';
import { useLocale } from 'locale';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import { FullscreenView } from 'components/unit-page/gallery/FullscreenView';
import { Route } from 'config/routes';
import { useScreenBreakpoint } from 'consts/breakpoints';

export type AgentImgSize = 'small' | 'large' | 'agent';

export interface TeamProps {
  agentId?: string;
  iconUrl?: string;
  officeImg?: string;
  name?: string;
  title?: string;
  size?: AgentImgSize;
  withOfficeLogo?: boolean;
  withButton?: boolean;
  isLeading?: boolean;
  fullSizeOn?: boolean;
  description?: string;
  type?: string;
  officeId?: string;
}

export const IMG_SIZE_LARGE = 296;
export const IMG_SIZE_SMALL = 168;
export const OFFICE_IMG_SIZE = 40;
export const AGENT_MOBILE_IMG_SIZE = 105;

export const getImgSize = (size: AgentImgSize) => ({
  large: IMG_SIZE_LARGE,
  small: IMG_SIZE_SMALL,
  agent: AGENT_MOBILE_IMG_SIZE,
}[size]);

export const Card: React.FC<TeamProps> = (props) => {
  const {
    iconUrl,
    name,
    title,
    size = 'large',
    officeImg,
    isLeading = false,
    officeId,
    withOfficeLogo,
    withButton,
    fullSizeOn = false,
  } = props;

  const { t } = useLocale();
  const constructImageURI = useImageUrlBuilder();
  const [ fullScreen, setFullScreen ] = useState(false);
  const breakpoint = useScreenBreakpoint();
  const isMobile = breakpoint <= 2;

  const imgSize = getImgSize(size);
  const agentImageUrl = constructImageURI(iconUrl, {
    width: imgSize,
    height: imgSize,
  });
  const officeImgUrl = constructImageURI(officeImg, {
    width: OFFICE_IMG_SIZE,
    height: OFFICE_IMG_SIZE,
  });

  const handleClose = () => () => setFullScreen(false);
  const handleOpen = agentImageUrl && fullSizeOn ? () => setFullScreen(true) : undefined;

  const fullSizeImgUrl = constructImageURI(iconUrl);

  return (
    <Styled.CardWrapper>
      <Styled.ImgWrapper onClick={handleOpen} imgSize={imgSize} size={size}>
        <Styled.ImgBGCover className="agent-logo-pagent">{agentImageUrl ? <img className="agent-logo" src={agentImageUrl} /> : <NoImageIcon />}</Styled.ImgBGCover>
      </Styled.ImgWrapper>
      {isLeading
        ? isMobile
          ? <Styled.MobLeadingLabel small weight="bold">{t('developerPage.members.promoted.label')}</Styled.MobLeadingLabel>
          : <Styled.LeadingLabel weight="bold">{t('developerPage.members.promoted.label')}</Styled.LeadingLabel>
        : null
      }
      {withOfficeLogo && officeImg ? <Styled.OfficeImg routeName={Route.OfficePage} routeParams={{ id: officeId, source: 'agent_page' }} imgSize={imgSize} officeSize={OFFICE_IMG_SIZE}><img src={officeImgUrl} /></Styled.OfficeImg> : null}
      {name || title ? (
        <Styled.TextWrapper>
          {name ? <Styled.Name>{name}</Styled.Name> : null}
          {title ? <Styled.Title>{title}</Styled.Title> : null}
        </Styled.TextWrapper>
      ) : null}
      {withButton ? <Button mode="ghost" size="extraLarge">{t('developerPage.members.moreAbout')}</Button> : null}
      {fullScreen ? (
        <FullscreenView
          images={[ { url: fullSizeImgUrl } ]}
          closeFullscreen={handleClose}
          slideIndex={0}
        />
      ) : null}
    </Styled.CardWrapper>
  );
};
